import { ACTIONS, TUTOR_STATE } from 'a/pictureThis/data/constants';

const initialState = {
  faceState: TUTOR_STATE.INACTIVE,
  onboarding: false,
  answerAffirmation: false,
  scaffold: false,
  prompt: false,
  stop: false,
};

const tutorState = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        faceState: TUTOR_STATE.ACTIVE,
      };

    case ACTIONS.START_POSITIVE_TUTOR_FEEDBACK:
      return {
        ...state,
        answerAffirmation: !state.answerAffirmation,
      };

    case ACTIONS.START_TUTOR_ONBOARDING:
      return {
        ...state,
        onboarding: !state.onboarding,
      };

    case ACTIONS.START_TUTOR_PROMPT:
      return {
        ...state,
        prompt: !state.prompt,
      };

    case ACTIONS.START_TUTOR_SCAFFOLD_PROMPT:
      return {
        ...state,
        scaffold: !state.scaffold,
      };

    case ACTIONS.STOP_TUTOR_SEQUENCE:
      return {
        ...state,
        stop: !state.stop,
      };

    case ACTIONS.SET_TUTOR_STATE:
      return {
        ...state,
        faceState: payload,
      };
    default:
      return state;
  }
};
export default tutorState;

export const getTutorState = state => state.faceState;

export const getTutorFeedbackTrigger = state => state.answerAffirmation;

export const getTutorOnboardingTrigger = state => state.onboarding;

export const getStopTutorTrigger = state => state.stop;

export const getTutorScaffoldTrigger = state => state.scaffold;

export const getTutorPromptTrigger = state => state.prompt;

export const getTutorStateCode = (state) => {
  switch (state.faceState) {
    case TUTOR_STATE.INACTIVE:
      return 0;
    case TUTOR_STATE.ACTIVE:
      return 1;
    case TUTOR_STATE.SPEAKING:
      return 2;
    default:
      return 0;
  }
};
